<template>
  <main class="primary">
    <slot />
  </main>
</template>
<style lang="scss" scoped>
main {
  background: white;
}
</style>
